import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import homeImage from './images/home.png';
import searchImage from './images/search.png';
import redesImage from './images/Redes100.png';
import infoImage from './images/info.png';
import userImage from './images/user.png';
import cofreImg from './images/cofre100.png';
import tiendaImg from './images/tienda112.png';
import overboxImg from './images/cofre112v2.png';
import misionesImg from './images/misiones112.png';
import ajustesImg from './images/ajustes112.png';
import { faccionKey } from '../utils/faccion';
import { useTutorial } from './components/Tutorial';

// Logueado, la foto de perfil abre el menu de la cuenta hacia arriba, en vertical para que
// quepan mas botones. Sin sesion lleva al login como siempre.
const MenuMain = ({ accountImage, faccion, isAuthenticated, missions, fetchMissions }) => {
    const [open, setOpen] = React.useState(false);
    // La barra mide distinto en movil y en escritorio: el menu se coloca justo encima de ella
    // midiendola al abrir, en vez de con un bottom fijo que acababa escondido detras.
    const [bottom, setBottom] = React.useState(null);
    const barRef = React.useRef(null);
    const { pathname } = useLocation();
    const tutorial = useTutorial();
    const toggle = () => {
        if (barRef.current) setBottom(barRef.current.offsetHeight + 8);
        setOpen(!open);
        // Paso del tutorial que enseña este menú (components/Tutorial.jsx)
        if (!open && tutorial && tutorial.paso === 'usuario') tutorial.avisar('menu');
    };

    // Se cierra al cambiar de pagina, al pulsar fuera y con Escape.
    React.useEffect(() => { setOpen(false); }, [pathname]);
    React.useEffect(() => {
        if (!open) return undefined;
        const outside = (e) => { if (!e.target.closest('.userExtender, #userExtendMenu')) setOpen(false); };
        const escape = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('click', outside);
        document.addEventListener('keydown', escape);
        return () => {
            document.removeEventListener('click', outside);
            document.removeEventListener('keydown', escape);
        };
    }, [open]);

    // El numero de misiones se refresca al cambiar de pagina; en la de misiones ya las pide ella.
    React.useEffect(() => {
        if (isAuthenticated && pathname !== '/myAccount/missions') fetchMissions();
    }, [isAuthenticated, pathname]);

    // Misiones sin reclamar: en verde si solo falta reclamarlas, en rojo si queda alguna por hacer.
    const pending = missions.filter(m => !m.claimed);
    const badge = pending.length > 0 ? (
        <span className={'menuBadge' + (pending.every(m => m.completed) ? ' claimable' : '')}
            aria-label={pending.length + ' misiones pendientes'}>{pending.length}</span>
    ) : null;

    const frame = accountImage ? 'accountImageBorder' : '';
    const avatar = <img src={accountImage ? accountImage : userImage} alt="Usuario" />;

    return (
        <>
            <div id="menu-main" className="noselect" ref={barRef}>
                <Link id="son" to="/"><img src={homeImage} alt="Inicio"/><span className="responsive">Inicio</span></Link>
                <Link id="son" to="/user"><img src={searchImage} alt="Explorar"/><span className="responsive">Explorar</span></Link>
                <div id='son' className='infoExtender'><img src={infoImage} alt="info"/><span className="responsive">Info</span></div>
                <Link id="son" to="/redes"><img src={redesImage} alt="Redes"/><span className="responsive">Redes</span></Link>
                {isAuthenticated ? (
                    <button type="button" id="son" className={'userExtender ' + frame} data-faccion={faccionKey(faccion)}
                        aria-expanded={open} aria-controls="userExtendMenu" onClick={toggle}>
                        {avatar}<span className="responsive">Usuario</span>{badge}
                    </button>
                ) : (
                    <Link id="son" to="/myAccount" className={frame} data-faccion={faccionKey(faccion)}>
                        {avatar}<span className="responsive">Usuario</span>
                    </Link>
                )}
            </div>
            {isAuthenticated ? (
                <nav id="userExtendMenu" className={'heroes' + (open ? ' show' : '')} aria-label="Tu cuenta"
                    style={bottom ? { bottom: bottom } : undefined} onClick={() => setOpen(false)}>
                    <Link to="/myAccount"><img src={accountImage ? accountImage : userImage} alt="" /><span>Mi perfil</span></Link>
                    <Link to="/myAccount/rewards"><img src={cofreImg} alt="" /><span>Inventario</span></Link>
                    <Link to="/myAccount/shop"><img src={tiendaImg} alt="" /><span>Tienda</span></Link>
                    <Link to="/myAccount/overbox"><img src={overboxImg} alt="" /><span>Overbox</span></Link>
                    <Link to="/myAccount/missions"><img src={misionesImg} alt="" /><span>Misiones</span>{badge}</Link>
                    <Link to="/myAccount/settings"><img src={ajustesImg} alt="" /><span>Ajustes</span></Link>
                </nav>
            ) : null}
        </>
    );
};

export default MenuMain;
